// G360_K470 - sort, filter, column choice and CSV export (the shared DataTable).
// G360_K462 - a failed read is said, not shown as an empty list or a zero; a refused change is said, not shown as done.
// Feature flags - roll features per-audience. Changes logged.
import { useEffect, useState } from 'react';
import { Flag } from 'lucide-react';
import { listFlags, setFlag } from '../lib/adminApi.js';
import { EmptyState } from '@govern360/shared/components/ui.jsx';
import { DataTable } from '@govern360/shared/components/datatable.jsx';

export default function FlagsPage() {
  const [flags, setFlags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadErr, setLoadErr] = useState('');
  useEffect(() => { listFlags().then(({ data, error }) => { setLoadErr(error ? (error.message || 'the read failed') : ''); setFlags(data); setLoading(false); }); }, []);

  async function toggle(f) {
    const { error } = await setFlag(f.id, !f.enabled);
    if (error) { alert('Flag not changed: ' + (error.message || 'refused')); return; }
    setFlags((prev) => prev.map((x) => (x.id === f.id ? { ...x, enabled: !x.enabled } : x)));
  }

  const COLS = [
    { key: 'key', label: 'Flag', render: (f) => <span className="mono" style={{ fontWeight: 500 }}>{f.key}</span> },
    { key: 'description', label: 'Description', render: (f) => <span style={{ color: 'var(--g-text-2)' }}>{f.description}</span> },
    { key: 'audience', label: 'Audience', render: (f) => <span className="pill p-gray">{f.audience}</span> },
    { key: 'enabled', label: 'State', value: (f) => (f.enabled ? 'on' : 'off'),
      render: (f) => <span className={`toggle ${f.enabled ? 'on' : ''}`} onClick={() => toggle(f)} style={{ cursor: 'pointer' }} title={f.enabled ? 'On - click to turn off' : 'Off - click to turn on'} /> },
  ];

  return (
    <div>
      <div className="ph"><div><h1 className="ph-h1">Feature flags</h1><p className="ph-sub">Roll features out per-audience or platform-wide.</p></div></div>
      {loading ? (
        <div className="card" style={{ textAlign: 'center', padding: 48, color: 'var(--g-text-2)' }}>Loading&hellip;</div>
      ) : loadErr ? (
        <div className="card g360-admin-err" style={{ padding: 24, borderLeft: '3px solid var(--g-danger)' }}>
          <p style={{ color: 'var(--g-danger)', fontSize: 14, margin: '0 0 8px' }}>Feature flags could not be read</p>
          <p style={{ fontSize: 13, color: 'var(--g-text-2)', margin: 0 }}>{loadErr}. This is not the same as there being none.</p>
        </div>
      ) : flags.length === 0 ? (
        <EmptyState icon={Flag} title="No flags yet" hint="Use Bootstrap demo on the overview page to add sample flags." />
      ) : (
        <DataTable rows={flags} columns={COLS} storageKey="g360.admin.flags.hiddenCols" name="feature-flags"
          placeholder="Filter flags..." rowKey={(f) => f.id} />
      )}
    </div>
  );
}
